import React, {useEffect} from "react";
import styled from "styled-components";
import {Button, Divider, Input, message, Space} from "antd";
import {useNavigate} from "react-router-dom";
import {useStore} from "../store";
import {observer} from "mobx-react";

const searchLogo = require("../image/search-logo.png")
const searchIcon = require("../image/search-icon.png")
const searchBg = require("../image/banner.png")
const leaf = require("../image/leaf.gif")
const specimen = require("../image/specimen.gif")
const threePic = require("../image/3D.gif")
const video = require("../image/video.gif")


const HomeSearch: React.FC = () => {
    const navigateTo = useNavigate();
    const {searchStore, searchGlobal} = useStore();

    useEffect(() => {
        searchStore.getInformation()
    }, []);

    const toSearchPage = () => {
        navigateTo("/home/search/advance")
    }

    const toSearchGlobal = () => {
        // if (!searchGlobal.searchWord) {
        //     message.error("请输入查询内容");
        //     return
        // }
        navigateTo("/home/search/global")
    }

    const onSearchChange = (e: any) => {
        searchGlobal.setSearchWord(e.target.value);
        // searchStore.setSearchKey(e.target.value);
    }

    const onKeyDown = (e: any) => {
        if (e.keyCode === 13) {
            toSearchGlobal()
        }
    }

    return (<Wrapper>
        <SearchWrapper>
            <SearchItemWrap>
                <SearchImg src={searchLogo}/>
                <SearchContentWrapper>
                    <SearchInputWrapper>
                        <Input
                            className={"inputSearch"}
                            onKeyDown={onKeyDown}
                            onChange={onSearchChange}
                            type={"search"}
                            placeholder="请输入关键信息检索"/>
                        <SearchIconWrapper onClick={toSearchGlobal}>
                            <img className={"search"} src={searchIcon}/>
                        </SearchIconWrapper>
                    </SearchInputWrapper>
                    <Button style={{marginLeft:"9px", alignSelf:"center", height:"40px", borderColor:"#1990FF", color: "white", background: "#1990FF"}} type={'default'} onClick={toSearchPage}>高级搜索</Button>
                </SearchContentWrapper>
            </SearchItemWrap>
        </SearchWrapper>
        <Space style={{alignSelf: "center", marginTop: "90px"}} align={"center"} size={"large"}>
            <CountWrapper>
                <CountImg src={leaf}/>
                <CountContent>
                    <span>标本记录</span>
                    <span>{searchStore.total}</span>
                </CountContent>
            </CountWrapper>
            <Divider style={{width:"2px", height:"100px", background:"#efefef"}} type={"vertical"}/>
            <CountWrapper>
                <CountImg src={specimen}/>
                <CountContent>
                    <span>标本图片</span>
                    <span>{searchStore.imageTotal}</span>
                </CountContent>
            </CountWrapper>
            <Divider style={{width:"2px", height:"100px", background:"#efefef"}} type={"vertical"}/>
            <CountWrapper onClick={() => window.open("/home/model")}>
                <CountImg src={threePic}/>
                <CountContent>
                    <span>3D模型</span>
                    {/*<span>{searchStore.modelTotal}</span>*/}
                    <span>3</span>
                </CountContent>
            </CountWrapper>
            <Divider style={{width:"2px", height:"100px", background:"#efefef"}} type={"vertical"}/>
            <CountWrapper>
                <CountImg src={video}/>
                <CountContent>
                    <span>视频</span>
                    <span>{searchStore.videoTotal}</span>
                </CountContent>
            </CountWrapper>
        </Space>
    </Wrapper>);
}

export default observer(HomeSearch);

const Wrapper = styled.div`
  & {
    display: flex;
    flex-direction: column;
    align-item: center;
    flex: 1;
  }
`;
const SearchWrapper = styled.div`
  & {
    background-image: url("${searchBg}");
    background-size: 100% 100%;
    width: 100%;
    display: flex;
    flex-direction: row;
    height: 60%;
  }
`;
const SearchImg = styled.img`
  & {
    width: 55px;
    height: 46px;
  }
`;
const SearchItemWrap = styled.div`
  & {
    display: flex;
    flex-direction: row;
    align-self: center;
    margin: 0 auto;

  }
`;
const CountWrapper = styled.div`
  & {
    display: flex;
    flex-direction: column;
    height: 190px;
    width: 280px;
    align-items: center;
  }
`;
const CountImg = styled.img`
  & {
    width: 60px;
    height: 60px;
  }
`;
const CountContent = styled.span`
  & {
    display: flex;
    flex-direction: column;
    justify-content: center;

    span:nth-child(1) {
      font-size: 18px;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      font-weight: bold;
      color: #333333;
      line-height: 27px;
      margin-top: 17px;
      text-align: center;
    }

    span:nth-child(2) {
      font-size: 18px;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      font-weight: bold;
      color: #999999;
      line-height: 27px;
      margin-top: 5px;
      text-align: center;
    }

  }
`;
const SearchContentWrapper = styled.div`
  & {
    display: flex;
  }
`;
const SearchInputWrapper = styled.div`
  & {
    display: flex;
    width: 700px;
    height: 48px;
    border-radius: 25px;

    .inputSearch {
      width: 627px;
      height: 48px;
      font-size: 16px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      color: black;
      border-radius: 25px 0 0 25px;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
      border: 1px solid rgba(16, 87, 218, 0.2);
      background: white;
    }
  }
`;
const SearchIconWrapper = styled.div`
  & {
    display: flex;
    justify-content: center;
    width: 73px;
    height: 48px;
    border-radius: 0 25px 25px 0;
    background: #1990FF;
    cursor: pointer;

    .search {
      width: 20px;
      height: 20px;
      align-self: center;
    }
  }
`;
const SearchButtonSpan = styled.span`
  & {
    font-size: 18px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    color: #1990FF;
    align-self: center;
    margin-left: 17px;
    cursor: pointer;
  }
`;
